"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReservationStatus = function ReservationStatus(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 -4 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#prefix__filter0_d_2709_1044)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 7.5,
    fill: color
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "prefix__filter0_d_2709_1044",
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    values: "0 0 0 0 0.466667 0 0 0 0 0.815686 0 0 0 0 0.980392 0 0 0 0.15 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2709_1044"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2709_1044",
    result: "shape"
  }))));
};
var _default = exports["default"] = ReservationStatus;